import React from 'react';
import PropTypes from 'prop-types';
export function DeleteConfrimationModal({ show, onClose, handleDelete, model }) {
    const handleConfirmDelete = () => {
        if (model?.id) {
            handleDelete(model);
            onClose();
        }
    };

    const handleOverlayClick = (e) => {
        if (e.target.className === 'admin-modal-overlay') {
            onClose();
        }
    };

    if (!show) {
        return null;
    }
    return (
        <div className="admin-modal-overlay" onClick={handleOverlayClick}>
            <div className="admin-modal">
                <h2 className="admin-modal-heading"> 
                    {model?.message}
                </h2>
                <div className="admin-modal-row full">
                    {model?.title && <div className="admin-modal-cell">{model?.title}</div> } 
                    {model?.description && <div className="admin-modal-cell">{model.description}</div> }
                </div>
                <div className="admin-modal-button-wrap">
                    <button className="admin-modal-button" onClick={onClose}>
                        Cancel
                    </button>
                    <button
                        className="admin-form-button power red"
                        onClick={handleConfirmDelete}
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
}

DeleteConfrimationModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired,
    model: PropTypes.object
};